import { useRoute } from 'shared/library/routes/route';
import { View } from 'react-native';
import { Props } from 'shared/@types';
import type { ComparisonCardBreed } from 'shared/library/compact-page-data';
import { Image } from 'shared/components/image';
import { Text } from 'shared/components/text';
import { Link } from 'shared/components/link';

const ComparisonCard = ({
  breed1,
  breed2,
}: Props<{ breed1: ComparisonCardBreed; breed2: ComparisonCardBreed }>) => {
  const route = useRoute();
  const [firstBreed, secondBreed] = breed1.id < breed2.id ? [breed1, breed2] : [breed2, breed1];

  return (
    <Link
      containerClassName={'bg-white'}
      href={route('breeds.show.compare.show', {
        breed: firstBreed.slug,
        comparable: secondBreed.slug,
      })}
      asBlock
    >
      <View className={'relative flex-row'}>
        <View className={'flex-1'}>
          <Image
            src={breed1.avatar}
            alt={breed1.name}
            containerClassName={'aspect-4/3 w-full'}
            imageClassName={'rounded-tl object-cover group-hover:opacity-75'}
            sizeType={'card'}
          />
        </View>

        <View
          className={
            'absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white p-2'
          }
        >
          <Text className={'text-brand-brown-dark text-sm font-bold md:text-base'}>VS</Text>
        </View>

        <View className={'flex-1'}>
          <Image
            src={breed2.avatar}
            alt={breed2.name}
            containerClassName={'aspect-4/3 w-full'}
            imageClassName={'rounded-tr object-cover group-hover:opacity-75'}
            sizeType={'card'}
          />
        </View>
      </View>

      <View className={'border-brand-brown-dark/15 rounded-b border border-t-0 p-3'}>
        <Text className={'text-brand-brown-dark text-center font-bold group-hover:underline'}>
          {breed1.name} vs {breed2.name}
        </Text>
      </View>
    </Link>
  );
};

export { ComparisonCard };
